import type { SVGProps } from "react";
export interface HeelsChunkyIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HeelsChunkyIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HeelsChunkyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.112 12.399a1.126 1.126 0 0 0 1.497-.178l.072-.09 2.466-3.481.061-.097a1.125 1.125 0 0 0-1.825-1.295l-.072.091-2.467 3.48-.061.097a1.126 1.126 0 0 0 .33 1.473Z"
      />
      <path
        fill={color}
        d="M20.875 18.064a.8.8 0 0 0-.378-.683l-3.39-2.125c-.812.298-2.454.758-4.159.331-2.278-.571-4.225-1.954-5.837-3.189-.836-.64-1.555-1.219-2.259-1.717q-.644-.455-1.172-.73c-.229.706-.482 1.674-.539 2.615-.068 1.13.103 2.458.138 2.82l.07.554c.163 1.066.482 2.198.71 2.93h1.054v-3.375a1.125 1.125 0 0 1 1.998-.71l.003.004.013.016.059.069a19 19 0 0 0 1.19 1.25c.82.789 1.97 1.763 3.313 2.548.217.127.492.198.802.198h7.58c.444 0 .803-.36.803-.806Zm2.25 0a3.055 3.055 0 0 1-3.055 3.056h-7.579a3.9 3.9 0 0 1-1.706-.383l-.232-.123c-1.257-.735-2.344-1.603-3.19-2.365v1.246l-.008.167a1.625 1.625 0 0 1-1.617 1.458H3.597c-.597 0-1.15-.329-1.43-.862l-.103-.24c-.217-.654-.71-2.228-.943-3.762l-.082-.651c-.025-.258-.226-1.82-.145-3.173.099-1.647.653-3.252.923-3.957l.058-.135c.306-.615 1.002-1.007 1.736-.842l.159.044.307.113c.718.287 1.415.722 2.074 1.188.75.53 1.554 1.177 2.328 1.77 1.607 1.23 3.23 2.344 5.016 2.791l.227.049c1.135.202 2.295-.174 2.806-.384l.179-.063a1.67 1.67 0 0 1 1.156.085l.184.101 3.645 2.282a3.06 3.06 0 0 1 1.433 2.59"
      />
    </svg>
  );
}
